<template lang="pug">
#myApplication
  .tabGroup
    el-radio-group(v-model="activeTab" size="small" @change="handleClick")
      el-radio-button(v-for="item in navList" :key="item.label" :label="item.label") {{ item.text }}
  .formSearch
    search(ref="approveSearch" :showPrjSelect="!isProject"  @change="handleSearch")
  .midd(v-loading="loading" element-loading-text="数据加载中")
    el-table(ref="multipleTable" border highlight-current-row size="small" height="100%"
      :data="tableData" :header-cell-style="headerStyle")
      el-table-column(type="index" label="编号" align="center" )
      el-table-column(label="状态" sortable prop="status" width="80px" align="center" v-slot="{row}")
        span.flowStatus(:class="`type${row.status}`") {{statusName(row.status)}}
      el-table-column(label="流程名称" sortable align="center" prop="flowType" width="130px")
      el-table-column(label="标题" align="center" sortable prop="title" min-width="200px" show-overflow-tooltip)
      el-table-column(label="内容" prop="content" align="center" min-width="200px" show-overflow-tooltip)
      el-table-column(label="申请人" prop="flowInstanceOwnerName" width="100px"  align="center")
      el-table-column(label="开始时间" prop="flowInstanceStartTime" align="center" width="120px" v-slot="{row}" show-overflow-tooltip)
        div(style="text-align: center;") {{ row.flowInstanceStartTime?.substring(0,10) }}
      el-table-column(label="当前审批人" align="center" prop="currentNodeAssigneeName" width="100px" show-overflow-tooltip)
      el-table-column(label="上个审批节点" align="center" prop="lastNodeName" width="120px" show-overflow-tooltip)
      el-table-column(label="操作" align="center" v-slot="{row}")
        el-button(type="text" v-if="row.status === 2" @click.stop="clickChange(row, 'edit')") 审批
        el-button(type="text" v-if="row.status !== 9 && row.status !== 2" @click.stop="clickChange(row, 'view')") 查看
        el-button(type="text" v-if="row.status === 0 || row.status === 3" @click.stop="clickChange(row,'again')") 重新发起
        el-button(type="text" v-if="row.status === 9" @click.stop="clickChange(row,'draft')") 编辑
        el-button(type="text" v-if="row.status === 9" @click.stop="delDraftFlow(row)") 删除
        export-excel(:row="row")
  .page
    el-pagination(:current-page.sync="page.pageNum"
      :page-size="page.pageSize"
      :layout="page.pageLayout"
      :total="page.totalCount"
      v-if="page.totalCount > 0"
      :page-sizes="[10, 20, 50, 100]"
      size="small"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange")
</template>

<script>
import { mapState } from "vuex";
import search from "@/CommonDP/pages/mainMg/approval/config/search.vue";
import flowService from "@/CommonDP/service/flow-service";
import { getStatusName } from "@/CommonDP/components/processComponents/config";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
import { exportExcel } from './export'
export default {
  components: { search, exportExcel: exportExcel() },
  props: {
    // 是否是项目内审批
    isProject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navList: [
        { label: "5", text: "全部" },
        { label: "1", text: "待处理" },
        { label: "2", text: "已处理" },
        { label: "3", text: "抄送我的" },
        { label: "4", text: "草稿" },
      ],
      activeTab: "5",
      loading: false,
      statusName: getStatusName,
      tableData: [],
      page: {
        pageLayout: "total, sizes, prev, pager, next, jumper",
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      mode: "add", // 发起流程还是审批流程 edit add
      viewMode: 0 // 新增0 审批1 查看2
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    searchFormParams() {
      if (this.isProject) {
        return {
          ...this.$refs.approveSearch.getForm(),
          prjId: this.prjInfo?.prjId
        };
      } else {
        return this.$refs.approveSearch.getForm();
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    async delDraftFlow(row) {
      await this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      await flowService.delDraftFlow(row.businessType, row.businessId);
      this.getList();
    },
    // 切换问题状态
    handleClick() {
      this.page.pageNum = 1;
      this.getList();
    },
    handleSearch(form) {
      this.page.pageNum = 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const url = flowService[this.requestUrl()];
      const res = await url(this.searchFormParams, this.page.pageNum, this.page.pageSize);
      this.tableData = res.data || [];
      this.loading = false;
      this.page.pageNum = res.pageIndex;
      this.page.totalCount = res.totalCount;
    },

    // 不同状态的接口
    requestUrl() {
      const requestName = {
        1: () => "myProcessing", // 待处理
        2: () => "myProcessed", // 已处理
        3: () => "cc", // 抄送我的
        4: () => "queryDraftPage", // 草稿
        5: () => "myAllApproveList" // 全部
      };
      return requestName[this.activeTab] ? requestName[this.activeTab]() : "";
    },
    updateTable() {
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 操作按钮
    async clickChange(row, approveType) {
      const { currentVersionId = "", flowInstanceId = "", flowKey, businessId = "", startMode } = row;
      const data = { currentVersionId, flowInstanceId, flowKey, approveType, businessId, enterpriseId: this.enterpriseId, isProject: this.isProject };
      // 新窗口打开
      if (startMode === "stdNew") {
        const routeUrl = this.$router.resolve({ path: "/examine-new", query: data });
        window.open(routeUrl.href, "_blank");
      } else {
        await openFlow(data);
        this.getList();
      }
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    }
  }
};
</script>

<style lang="scss" scoped>
#myApplication {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0 var(--big-space);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .approveSearch {
    padding: 10px 0;
  }

  .midd {
    flex: 1 1;
    overflow: hidden;
  }
}
.tabGroup{
  padding: var(--middle-space) 0;
}

.el-table::before {
  height: 1px !important;
}

.page {
  padding: var(--middle-space) 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.flowStatus {
  border-radius: 6px;
  text-align: center;
  padding: 2px 8px;
}
.type1,.type4{
  border: 1px solid #10A667;
  background: rgba(16, 166, 103, 0.10);
  color: #10A667;
}

.type2 {
  border: 1px solid #FF7A00;
  background: rgba(255, 122, 0, 0.10);
  color: #FF7A00;
}

.type3 {
  border: 1px solid #60656B;
  background: rgba(96, 101, 107, 0.10);
  color: #60656B;
}

.type8 {
  border: 1px solid #9746E8;
  background: rgba(151, 70, 232, 0.10);
  color: #9746E8;
}

.type9 {
  border: 1px solid #2F8BF8;
  background: rgba(47, 139, 248, 0.10);
  color: #2F8BF8
}

.type0 {
  border: 1px solid #FF4A4A;
  background: rgba(255, 74, 74, 0.10);
  color: #FF4A4A;
}

</style>
